import React from 'react';

export const MastercardIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1436_43707)">
        <path
          d="M21.75 0.25H2.25C1.14543 0.25 0.25 1.14543 0.25 2.25V13.75C0.25 14.8546 1.14543 15.75 2.25 15.75H21.75C22.8546 15.75 23.75 14.8546 23.75 13.75V2.25C23.75 1.14543 22.8546 0.25 21.75 0.25Z"
          fill="white"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.5"
        />
        <g clipPath="url(#clip1_1436_43707)">
          <path
            d="M13.4883 4.21191H9.55078V11.2869H13.4883V4.21191Z"
            fill="#FF5F00"
          />
          <path
            d="M9.80034 7.74909C9.80034 6.37409 10.4378 5.06159 11.5128 4.21159C9.56284 2.67409 6.72534 3.01159 5.18784 4.97409C3.66284 6.92409 4.00034 9.74909 5.96284 11.2866C7.60034 12.5741 9.88784 12.5741 11.5253 11.2866C10.4378 10.4366 9.80034 9.12409 9.80034 7.74909Z"
            fill="#EB001B"
          />
          <path
            d="M18.8004 7.74909C18.8004 10.2366 16.7879 12.2491 14.3004 12.2491C13.2879 12.2491 12.3129 11.9116 11.5254 11.2866C13.4754 9.74909 13.8129 6.92409 12.2754 4.96159C12.0504 4.68659 11.8004 4.42409 11.5254 4.21159C13.4754 2.67409 16.3129 3.01159 17.8379 4.97409C18.4629 5.76159 18.8004 6.73659 18.8004 7.74909Z"
            fill="#F79E1B"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1436_43707">
          <rect width="24" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_1436_43707">
          <rect
            width="19.05"
            height="13.5"
            fill="white"
            transform="translate(2 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
